import addProfilePictureDark from './addProfilePictureDark.svg';
import addProfilePictureLight from './addProfilePictureLight.svg';
import changeSiteThemeDark from './changeSiteThemeDark.svg';
import changeSiteThemeLight from './changeSiteThemeLight.svg';
import createPageDark from './createPageDark.svg';
import createPageLight from './createPageLight.svg';
import createSpaceDark from './createSpaceDark.svg';
import createSpaceLight from './createSpaceLight.svg';
import createWhiteboardDark from './createWhiteboardDark.svg';
import createWhiteboardLight from './createWhiteboardLight.svg';
import downloadMobileAppDark from './downloadMobileAppDark.svg';
import downloadMobileAppLight from './downloadMobileAppLight.svg';
import explorePremiumDark from './explorePremiumDark.svg';
import explorePremiumLight from './explorePremiumLight.svg';

export const cards = {
	createPage: {
		light: createPageLight,
		dark: createPageDark,
	},
	createSpace: {
		light: createSpaceLight,
		dark: createSpaceDark,
	},
	createWhiteboard: {
		light: createWhiteboardLight,
		dark: createWhiteboardDark,
	},
	addProfilePicture: {
		light: addProfilePictureLight,
		dark: addProfilePictureDark,
	},
	changeSiteTheme: {
		light: changeSiteThemeLight,
		dark: changeSiteThemeDark,
	},
	explorePremium: {
		light: explorePremiumLight,
		dark: explorePremiumDark,
	},
	downloadMobileApp: {
		light: downloadMobileAppLight,
		dark: downloadMobileAppDark,
	},
} as const;
